import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

// On-load signature moment, rebuilt crisp & scalable from the brand splash:
// "Welcome to" → glowing INDRIL mark → wordmark → loader → curtain wipe.
export const Preloader = () => {
  return (
    <motion.div
      data-testid={HOME.preloader}
      className="pointer-events-none fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden bg-zinc-950"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[32rem] w-[32rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-indril-saffron/20 blur-[130px]" />

      <motion.p
        className="mb-4 font-display text-2xl font-medium tracking-tight sm:text-3xl"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.6 }}
      >
        <span className="text-white">Welcome </span>
        <span className="text-indril-saffron">to</span>
      </motion.p>

      <motion.img
        src="/indril-mark.png"
        alt="INDRIL"
        className="relative w-32 sm:w-40"
        initial={{ opacity: 0, scale: 0.75, filter: "blur(14px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ delay: 0.3, duration: 1, ease: [0.16, 1, 0.3, 1] }}
      />

      <motion.img
        src="/indril-wordmark.png"
        alt="INDRIL — India's Own Social Media Platform"
        className="mt-5 w-64 sm:w-80"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      />

      <motion.div
        className="mt-14 h-8 w-8 rounded-full border-2 border-white/10 border-t-indril-saffron"
        animate={{ rotate: 360 }}
        transition={{ duration: 0.9, repeat: Infinity, ease: "linear" }}
      />
      <motion.p
        className="mt-5 text-sm tracking-wide text-white/50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.6 }}
      >
        Loading your experience…
      </motion.p>
    </motion.div>
  );
};
